import apiClient from '@/services/axios'
import { transformIntoQuery } from '@/utils/pagination'

class SellerAuctionService {
  constructor() {
    this.$api = apiClient
  }

  getAuctions (pagination, sort, filter) {
    const query = transformIntoQuery(pagination, sort, filter)
    return this.$api.get(`/seller/auctions${query}`)
  }

  getAuctionById(id) {
    return this.$api.get(`seller/auctions/${id}`)
  }

  sendBid(value, id) {
    const body = {
      bidAmount: value,
      auctionId: id,
    }
    return this.$api.post('seller/auctions/makebid', body)
  }

  editPrize(payload) {
    return this.$api.post('seller/auctions/editPrize', payload)
  }

  sendPayment(payload) {
    return this.$api.post('seller/auctions/pay', payload)
  }

  confirmPayment(payload) {
    return this.$api.post('seller/auctions/payConfirm', payload)
  }
}

export default new SellerAuctionService()
